export const settings = {
  wordset: [
    {
      title: 'Schriftliches Bennenen',
      subTitles: [
        {
          title: 'Aufgabentyp',
          globalStateName: 'setting',
          data: [
            {
              label: 'Lückenwort',
              value: 'gap',
            },
            {
              label: 'Anagramme',
              value: 'anagram',
            },
            {
              label: 'Ganze Tastatur',
              value: 'full',
            },
          ],
        },
      ],
      variableTitles: {
        full: {
          title: '',
          data: [],
          globalStateName: 'value',
        },
        anagram: {
          title: 'Anzahl Zusatzgrapheme',
          data: [0, 1, 2, 3, 4],
          globalStateName: 'value',
        },
        gap: {
          title: 'Anzahl Lücken',
          data: [1, 2, 3, 4],
          globalStateName: 'value',
        },
      },
    },
    {
      title: 'Mündliches Bennenen',
      subTitles: [
        {
          globalStateName: 'setting',
          title: '',
          data: [
            {
              label: 'Mit Audioaufnahme',
              globalStateName: 'setting',
              value: 'record',
            },
            {
              label: 'Ohne Audioaufnahme',
              globalStateName: 'setting',
              value: 'norecord',
            },
          ],
        },
        {
          globalStateName: 'value',
          title: 'Aufnahmedauer',
          isNotRadio: true,
          data: [5, 20],
          sliderLabel: 'Sekunden',
        },
      ],
    },
    {
      title: 'Auditives Sprachverständnis',
      subTitles: [
        {
          title: 'Ablenker',
          globalStateName: 'setting',
          data: [
            {
              label: 'Unrelatiert',
              value: 'unrelated',
            },
            {
              label: 'Semantisch',
              value: 'related',
            },
            {
              label: 'Aus Set',
              value: 'fromset',
            },
          ],
        },
        {
          title: 'Anzahl Bilder',
          globalStateName: 'value',
          data: [
            { label: 2, value: 2 },
            { label: 3, value: 3 },
            { label: 4, value: 4 },
          ],
        },
      ],
    },
    {
      title: 'Lesesinnverständnis',
      subTitles: [
        {
          title: 'Ablenker',
          globalStateName: 'setting',
          data: [
            {
              label: 'Unrelatiert',
              value: 'unrelated',
            },
            {
              label: 'Semantisch',
              value: 'related',
            },
            {
              label: 'Aus Set',
              value: 'fromset',
            },
          ],
        },
        {
          title: 'Anzahl Bilder',
          globalStateName: 'value',
          data: [
            { label: 2, value: 2 },
            { label: 3, value: 3 },
            { label: 4, value: 4 },
          ],
        },
      ],
    },
  ],
  sentenceset: [
    {
      title: 'Schriftliches Bennenen',
      subTitles: [
        {
          title: 'Aufgabentyp',
          globalStateName: 'setting',
          data: [
            {
              label: 'Lückensatz',
              value: 'gap',
            },
            {
              label: 'Anagramme',
              value: 'anagram',
            },
            {
              label: 'Ganze Tastatur',
              value: 'full',
            },
          ],
        },
      ],
      variableTitles: {
        full: {
          title: '',
          data: [],
          globalStateName: 'value',
        },
        anagram: {
          title: 'Anzahl Zusatzwörter',
          data: [0, 1, 2, 3, 4],
          globalStateName: 'value',
        },
        gap: {
          title: 'Anzahl Lücken',
          data: [1, 2, 3, 4],
          globalStateName: 'value',
        },
      },
    },
    {
      title: 'Mündliches Bennenen',
      subTitles: [
        {
          globalStateName: 'setting',
          title: '',
          data: [
            {
              label: 'Mit Audioaufnahme',
              globalStateName: 'setting',
              value: 'record',
            },
            {
              label: 'Ohne Audioaufnahme',
              globalStateName: 'setting',
              value: 'norecord',
            },
          ],
        },
        {
          globalStateName: 'value',
          title: 'Aufnahmedauer',
          isNotRadio: true,
          data: [5, 20],
          sliderLabel: 'Sekunden',
        },
      ],
    },
    {
      title: 'Auditives Sprachverständnis',
      subTitles: [
        {
          title: 'Ablenker',
          globalStateName: 'setting',
          data: [
            {
              label: 'Unrelatiert',
              value: 'unrelated',
            },
            {
              label: 'Semantisch',
              value: 'related',
            },
            {
              label: 'Aus Set',
              value: 'fromset',
            },
          ],
        },
        {
          title: 'Anzahl Bilder',
          globalStateName: 'value',
          data: [
            { label: 2, value: 2 },
            { label: 3, value: 3 },
            { label: 4, value: 4 },
          ],
        },
      ],
    },
    {
      title: 'Lesesinnverständnis',
      subTitles: [
        {
          title: 'Ablenker',
          globalStateName: 'setting',
          data: [
            {
              label: 'Unrelatiert',
              value: 'unrelated',
            },
            {
              label: 'Semantisch',
              value: 'related',
            },
            {
              label: 'Aus Set',
              value: 'fromset',
            },
          ],
        },
        {
          title: 'Anzahl Bilder',
          globalStateName: 'value',
          data: [
            { label: 2, value: 2 },
            { label: 3, value: 3 },
            { label: 4, value: 4 },
          ],
        },
      ],
    },
  ],
  textset: [
    {
      title: 'Schreiben',
      subTitles: [
        {
          title: '',
          globalStateName: 'setting',
          data: [
            {
              label: 'Lückentext',
              value: 'gap',
            },
            {
              label: 'Diktat schreiben',
              value: 'diktat',
            },
          ],
        },
      ],
    },
    {
      title: 'Mündliches Nacherzählen',
      subTitles: [
        {
          globalStateName: 'setting',
          title: '',
          data: [
            {
              label: 'W-Fragen geleitet',
              globalStateName: 'setting',
              value: 'questions',
            },
          ],
        },
      ],
    },
    {
      title: 'Auditives Sprachverständnis',
      subTitles: [
        {
          title: 'Audiogeschwindigkeit',
          globalStateName: 'audioSpeedSetting',
          data: [
            {
              label: 'Normal',
              value: 'normal',
            },
            {
              label: 'Langsam',
              value: 'slow',
            },
          ],
        },
        {
          title: 'Art der Fragen',
          globalStateName: 'setting',
          data: [
            { label: 'Geschlossen', value: 'closed' },
            { label: 'Offen', value: 'open' },
          ],
        },
      ],
      variableTitles: {
        open: {
          title: '',
          data: [],
          globalStateName: 'value',
        },
        closed: {
          title: 'Anzahl der Antwortmöglichkeiten',
          data: [2, 3, 4],
          globalStateName: 'value',
        },
      },
    },
    {
      title: 'Lesesinnverständnis',
      subTitles: [
        {
          title: 'Art der Fragen',
          globalStateName: 'setting',
          data: [
            { label: 'Geschlossen', value: 'closed' },
            { label: 'Offen', value: 'open' },
          ],
        },
      ],
      variableTitles: {
        open: {
          title: '',
          data: [],
          globalStateName: 'value',
        },
        closed: {
          title: 'Anzahl der Antwortmöglichkeiten',
          data: [2, 3, 4],
          globalStateName: 'value',
        },
      },
    },
  ],
};
